module.exports = __webpack_public_path__ + "static/media/Cabin-Regular.46cdb386.ttf";